import instagramIcon from "../images/instagramicon.png"
import youtubeIcon from "../images/youtubeicon.png"
import pinterestIcon from "../images/pinteresticon.png"
import linkedIcon from "../images/LI-White.png"
import facebookIcon from "../images/FB-White.png"

import footerFacebook from "../images/FB.png"
import footerInsta from "../images/Instagram_w_K.png"
//import footerTwitter from "../images/Twitter.png"
import footerTikTok from "../images/tiktok.png"

export const icons = [
  {
    icon: instagramIcon,
    alt: "instagram",
    link: "https://www.instagram.com/nutrafol/",
  },
  {
    icon: facebookIcon,
    alt: "facebook",
    link: "https://www.facebook.com/nutrafol/",
  },
  {
    icon: linkedIcon,
    alt: "linkedIn",
    link: "https://www.linkedin.com/company/nutrafol",
  },
  {
    icon: pinterestIcon,
    alt: "pinterest",
    link: "https://www.pinterest.com/nutrafol/",
  },
  {
    icon: youtubeIcon,
    alt: "youtube",
    link: "https://www.youtube.com/channel/UC2nh3Daj0KnLD7N7WVaCGwA",
  },
]

export const footerIcons = [
  {
    icon: footerFacebook,
    alt: "facebook",
    link: "https://www.facebook.com/nutrafol/",
  },
  {
    icon: footerInsta,
    alt: "instagram",
    link: "https://www.instagram.com/nutrafol/",
  },
  {
    icon: footerTikTok,
    alt: "tiktok",
    link: "https://www.tiktok.com/@nutrafol",
  },
]
